import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'cp-priority-tooltip',
    templateUrl: './priority-tooltip.component.html',
    styleUrls: ['./priority-tooltip.component.scss'],
    standalone: false
})
export class PriorityTooltipComponent {

    @Input() data: any;
    @Input() featureFlag: boolean;
    @Input() filterState: {
        priorities: Record<string, boolean>;
        subPriorities: Record<string, boolean>;
    } = {
        priorities: {},
        subPriorities: {}
    };

    @Output() toggleFilter = new EventEmitter<{ type: string; id: string }>();
    @Output() mouseLeave? = new EventEmitter<boolean>();

    filter(priorityId: string){
        this.toggleFilter.emit({ type: 'priority', id: priorityId });
    }

    filterSub(subpriorityId: string){
        this.toggleFilter.emit({ type: 'subPriority', id: subpriorityId });
    }

    closeTooltip(){
        this.mouseLeave.emit(false);
    }

}
